import { render, staticRenderFns } from "./MediaBlock.vue?vue&type=template&id=25392b62&scoped=true&"
import script from "./MediaBlock.vue?vue&type=script&lang=js&"
export * from "./MediaBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25392b62",
  null
  
)

export default component.exports